import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

const initialState = {
  dailyCollection: {
    responseData: {},
    loading: false,
  },
};

// Company-wide daily income collected per department + TAR.
// Read-only - sums `income` directly. See docs/department_income_tar_tracking.md
// in node-portal-from-29-08-2022.
export const getDepartmentDailyCollection = createAsyncThunk(
  'departmentIncomeTracker/getDepartmentDailyCollection',
  async (dispatchParams) => {
    const params = { month: dispatchParams.month };
    if (dispatchParams.skillx) params.skillx = 'true';
    const urlParams = new URLSearchParams(params);
    const url = `/department-income-tracker/daily-collection?${urlParams}`;
    const res = await apiRequest({ method: 'get', url });
    return res;
  },
);

const departmentIncomeTrackerSlice = createSlice({
  name: 'departmentIncomeTracker',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDepartmentDailyCollection.pending, (state) => {
      state.dailyCollection.loading = true;
    });
    builder.addCase(getDepartmentDailyCollection.fulfilled, (state, action) => {
      state.dailyCollection.loading = false;
      // The backend's response() helper hoists `data.meta`/`data.data` to the top level of
      // the envelope (see src/models/api/response.model.js), so the envelope itself already
      // has both `.meta` and `.data` - store it whole, don't unwrap `.data` again here.
      state.dailyCollection.responseData = action.payload || {};
    });
    builder.addCase(getDepartmentDailyCollection.rejected, (state) => {
      state.dailyCollection.loading = false;
    });
  },
});

export default departmentIncomeTrackerSlice.reducer;
